import {
  Button,
  Col,
  Divider,
  Drawer,
  Modal,
  Row,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import { CheckCircleOutlined } from "@ant-design/icons";

const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">{title}:</p>
    {/* <Typography style={{ fontWeight: "bold", fontStyle: "italic" }}> */}
    <b>
      <i>{content}</i>
    </b>
    {/* </Typography> */}
  </div>
);

const FiledReportDetails = ({
  open,
  close,
  getReportFiledList,
  selectedData,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setConfirmDialog(false);
      setConfirmLoading(false);
      handleMarkAsComplete();
    }, 2000);
  };

  //   console.log("selectedData", selectedData);

  const handleMarkAsComplete = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData.id !== null ? selectedData.id : "");
    setLoadings(true);
    axios
      .post("user/commissary/update/filed-report", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Mark as complete successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            getReportFiledList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      //   title="Filed report details"
      width={window.innerWidth > 710 ? 500 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <div
      //   style={{ overflowX: "auto", padding: paddingPrint }}
      //   ref={componentRef}
      >
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 10 }}
        >
          <div style={{ flexGrow: 1 }}>
            <p className="site-description-item-profile-p">Filed Report</p>
          </div>
        </div>
        <Row>
          <Col span={24}>
            <DescriptionItem
              title="Merchant"
              content={`${
                selectedData.reportfilemerchantinfo.business_name !== null
                  ? selectedData.reportfilemerchantinfo.business_name
                  : ""
              }`}
            />
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <DescriptionItem
              title="Description"
              content={`${
                selectedData.description !== null
                  ? selectedData.description
                  : ""
              }`}
            />
          </Col>
        </Row>
        <Divider />

        {parseInt(selectedData.commissary_approved) === 0 && (
          <Button
            type="default"
            icon={<CheckCircleOutlined />}
            onClick={() => setConfirmDialog(true)}
            style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
            disabled={loadings}
          >
            Mark as complete
          </Button>
        )}
      </div>

      <Modal
        title="Are you sure to mark this complete?"
        open={confirmDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setConfirmDialog(false)}
        centered
      />
    </Drawer>
  );
};

export default FiledReportDetails;
